import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const QuoteLeft = ({ className }) => {
  return (
    <svg
      viewBox='0 0 39 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-quote-left', { [className]: className })}
    >
      <path
        d='M13 0C3.6 2.79999 0 8.10001 0 16.4V31.8H17.1V15.5H9.1V15.2C9.1 10.7 10.4 8.5 16.3 6.60001L13 0ZM34.7 0C25.3 2.79999 21.7 8.10001 21.7 16.4V31.8H38.7V15.5H30.8V15.2C30.8 10.7 32.1 8.5 37.9 6.60001L34.7 0Z'
        fill='currentColor'
      />
    </svg>
  );
};

QuoteLeft.propTypes = {
  className: PropTypes.string,
};

export default QuoteLeft;
